import AddressSearch from 'components/AddressSearch';
import Loading from 'components/Loading';
import styled from 'styled-components';
import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store/rootReducer';
import NormalBldInfoModal from './NormalBldInfoModal';
import NormalMap from './NormalMap';

function NormalMapHome() {
  const { modal } = useSelector((state: RootState) => state.mapStore);
  return (
    <>
      <Container>
        <AddressSearch />
        <RenderAfterNavermapsLoaded
          ncpClientId={`${process.env.REACT_APP_NAVER_MAP_KEY}`}
          error={<Loading />}
          loading={<Loading />}
        >
          <NormalMap />
        </RenderAfterNavermapsLoaded>
      </Container>
      {modal && <NormalBldInfoModal />}
    </>
  );
}

export default NormalMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;
